// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/Sidebar.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/Sidebar.tsx");
  import.meta.hot.lastModified = "1727904225310.825";
}
// REMIX HMR END

import SocialShare from "~/components/static/SocialShare";
import { CTA, TableOfContent } from "~/components";
export default function Sidebar({
  node,
  activeSection,
  links
}) {
  return <div>
      <TableOfContent activeSection={activeSection} links={links} />
      <SocialShare />
      {node.cta && <CTA {...node.cta} size="small" />}
    </div>;
}
_c = Sidebar;
var _c;
$RefreshReg$(_c, "Sidebar");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;